import React, { useState } from 'react';

export default function ImageLoader(props) {
    const initialState = { className: "Loading"}

    const [State, setState] = useState(initialState)

    const setLoaded = () => {
        setState({ className: 'Loaded' })
    }
 

    return (
        <img
            className={State.className}
            src={props.media}
            alt="article"
            srcSet={props.srcSet}
            sizes={props.srcSet == null ? null : `(min-width: 1200px) 1536px, (max-width: 1200px) and (min-width: 1024px) 1024px, (max-width: 1024px) and (min-width: 600px) 600px, (max-width: 600px) and (min-width: 460px) 460px, (max-width: 460px) 300px`}

            onLoad={setLoaded} />
    );
}


